import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTopOnRouteChange
 *
 * Restores window scroll position to the top whenever the SmartEvaluate
 * route segment changes (back/forward/continue navigation between intake,
 * select-mode, client-info, rfp-intake, module-1/2/3, submitted, resume).
 *
 * Scoped to the SmartEvaluate URL hierarchy so non-SmartEvaluate pages are
 * not affected.
 */
export default function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    const isSmartEvaluate =
      pathname.startsWith("/evaluate") ||
      pathname.startsWith("/warehousex/smartstrategy/smartevaluate");
    if (!isSmartEvaluate) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
